module.exports = __webpack_public_path__ + "img/background-precos.ca98969b.png";